/*eslint-disable */
<template>
  <div class="iq-card p-3 testprep-card">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5 class="m-bold pl-2 w-100 pr-2 mb-0">
        Testprep Performance (Super Scores)
      </h5>
    </div>

    <div v-if="loading" class="text-center py-3">
      <div class="spinner-border spinner-border-sm text-danger" role="status"></div>
    </div>

    <div v-else-if="examList.length" class="pt-1">
      <div
        v-for="exam in examList"
        :key="exam.interest_id"
        class="educationCard pt-2 pl-2 pr-2 pb-3 mb-3"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="m-0 font-weight-bold d-flex align-items-center">
            <span class="text-danger font-size-16 mr-1">&raquo;</span>{{ exam.name }}
            <i class="fa-solid fa-graduation-cap font-size-20 pointer primary-color ml-3" title="View Details" @click="goToTestPrepDetails(exam)"></i>
            <i class="fa-solid fa-chart-pie font-size-20 pointer primary-color ml-3" title="View Analytics" @click="goToAnalyticsV1Report(exam)"></i>
          </h6>
        </div>

        <div v-if="exam.headers && exam.headers.length" class="score-grid">
          <div class="d-flex score-row score-header-row">
            <div
              v-for="(header, index) in exam.headers"
              :key="exam.interest_id + '_h_' + index"
              class="score-cell font-weight-bold text-dark"
            >
              {{ header }}
            </div>
            <div class="score-cell font-weight-bold text-dark">Total Score</div>
          </div>

          <div class="d-flex score-row">
            <div
              v-for="(scoreObj, index) in exam.scoresList"
              :key="exam.interest_id + '_s_' + index"
              class="score-cell text-secondary"
            >
              {{ scoreObj.app_score }} / {{ scoreObj.app_total_score }}
            </div>
            <div class="score-cell font-weight-bold text-dark">{{ exam.score_obtained }} / {{ exam.totalScore }}</div>
          </div>
        </div>

        <div v-else class="score-empty-state">
          No score available yet. Attempt a mock test to view your performance.
        </div>
      </div>
    </div>

    <div v-else class="mb-2 ml-2 text-muted">
      No test prep exam data available.
    </div>
  </div>
</template>

<script>
import { TprepAnalytics } from "../../FackApi/api/TprepAnalytics.js"
import { TprepSessions } from "../../FackApi/api/TprepSession.js"
import AppChainOrder from "../../Utils/appChainOrder.js"

export default {
  name: "TestPrep",
  props: {
    studentUserId: {
      type: String,
      required: true
    },
    allowAdd: {
      type: Boolean,
      default: false
    },
    programTests: {
      type: [Array, Object],
      default: () => ([])
    }
  },
  data () {
    return {
      loading: false,
      examList: []
    }
  },
  watch: {
    studentUserId: {
      immediate: true,
      async handler (userId) {
        if (userId) {
          await this.loadTestPrepData()
        }
      }
    }
  },
  methods: {
    /**
     * Infer domain for analytics payload
     */
    inferExamDomain (interestId) {
      const id = String(interestId || "").toUpperCase()
      if (id.includes("SAT")) return "sat"
      if (id.includes("CUET_SCIENCE")) return "cuet-science"
      if (id.includes("CUET_COMMERCE")) return "cuet-commerce"
      if (id.includes("CUET_HUMANITIES")) return "cuet-humanities"
      if (id.includes("AP")) return "ap"
      return "clat"
    },

    /**
     * Fetch student's exam interest list
     */
    async tprepExamNameList () {
      try {
        const payload = {
          user_id: this.studentUserId,
          gide_user_id: this.studentUserId
        }

        const tprepSubjectListResp = await TprepSessions.tprep_exam_name_list(this, payload)
        if (tprepSubjectListResp?.resp_status) {
          let interestList = tprepSubjectListResp.resp_data?.data || []
          return interestList
        }
      }
      catch (err) {
        console.error("Exception occurred at tprepExamNameList():", err.message)
      }

      return []
    },
    /**
     * Fetch performance data for a specific interest ID
     */
    async getPerformanceData (interestId) {
      try {
        const payload = {
          tprep_mock_interest_id: interestId,
          gide_user_id: this.studentUserId,
          app_domain: this.inferExamDomain(interestId)
        }
        const response = await TprepAnalytics.tprep_analyticsHomepagePerfomaceData(this, payload)

        if (response?.resp_data?.data) {
          const perfData = response.resp_data.data
          let subjectScores = perfData.subject_wise_best_score || {}

          // Apply reordering utility if present
          if (AppChainOrder && typeof AppChainOrder.reorderObjectBasedOnSetConfig === "function") {
            subjectScores = AppChainOrder.reorderObjectBasedOnSetConfig(subjectScores, null, this.$store)
          }

          const entries = Object.entries(subjectScores)

          // Extract app_ids, aprs_ids, and attempt from root or modules
          const appIdList = entries.map(([, val]) => val?.app_id || val?.modules?.[0]?.app_id || null)
          const aprsIdList = entries.map(([, val]) => val?.aprs_id || val?.modules?.[0]?.aprs_id || "")
          const attempts = entries.map(([, val]) => val?.attempt || val?.modules?.[0]?.attempt || 1)

          const appId = perfData?.super_score?.app_id || appIdList[0] || null
          const aprsId = perfData?.super_score?.aprs_id || aprsIdList[0] || ""
          const attempt = perfData?.super_score?.attempt || attempts[0] || 1

          const headers = entries.map(([key, val]) => val?.app_name_alias || key)
          const scoresList = entries.map(([, val]) => {
            const valScore = val?.score ?? val?.app_score ?? 0
            let score = typeof valScore === "number" ? Number(valScore.toFixed(2)) : valScore

            const totalScore = val?.app_total_score ?? val?.app_total_score ?? 0
            let appTotalScore = typeof totalScore === "number" ? Number(totalScore.toFixed(2)) : totalScore

            return { app_score: score, app_total_score: appTotalScore }
          })

          const displayName = interestId.replace("TESTSERIES_", "").replaceAll("_", " ")

          return {
            interest_id: interestId,
            name: displayName,
            headers: headers,
            scoresList: scoresList,
            app_total_score: perfData?.super_score?.total_score ?? 0,
            score_obtained: perfData?.super_score?.score_obtained ?? 0,
            totalScore: perfData?.super_score?.total_score ?? 0,
            hasData: entries.length > 0 || (perfData?.super_score?.score_obtained !== undefined),
            app_id: appId,
            app_ids: appIdList,
            aprs_id: aprsId,
            aprs_ids: aprsIdList,
            attempt: attempt
          }
        }
      }
      catch (err) {
        console.error(`Exception in getPerformanceData() for ${interestId}:`, err.message)
      }
      return null
    },
    /**
     * Main Loader method: Fetch matched exams and scores
     */
    async loadTestPrepData () {
      this.loading = true
      try {
        // 1. Fetch interest IDs for student
        const interestList = await this.tprepExamNameList()
        if (!interestList || !interestList.length) {
          return
        }

        // 2. Extract interest_id list
        const interestIds = interestList.map(item => item?.interest_id).filter(Boolean)

        // 3. Fetch analytics for each interest_id in parallel
        const promises = interestIds.map(id => this.getPerformanceData(id))
        const results = await Promise.all(promises)

        // 4. Filter out empty/null entries and assign to examList
        this.examList = results.filter(exam => exam !== null)
      }
      catch (err) {
        console.error("Exception in loadTestPrepData():", err.message)
        this.examList = []
      }
      finally {
        this.loading = false
      }
    },
    /**
     * goTo Test Prep Details
     */
    goToTestPrepDetails (appData) {
      if (!appData || !appData.interest_id) return

      const userId = this.studentUserId
      const interestId = appData.interest_id || ""

      const detailsUrl = `/subject_modules/${interestId}?gide_user_id=${userId}`

      window.open(detailsUrl, "_blank")
    },
    /**
     * goTo AnalysisV1 Report
     */
    goToAnalyticsV1Report (appData) {
      if (!appData || !appData.interest_id) return

      // const appId = appData.app_id
      const userId = this.studentUserId
      const interestId = appData.interest_id || ""
      // const aprsId = appData.aprs_id || ""
      // const attempt = appData.attempt || 1

      const analyticsUrl = `/analytics?gide_user_id=${userId}&interest_id=${interestId}`

      window.open(analyticsUrl, "_blank")
    }
  }
}
</script>

<style scoped lang="scss">
.testprep-card {
  .score-grid {
    overflow-x: auto;
  }

  .score-row {
    min-width: 480px;
    border-bottom: 1px solid #f0f0f0;
    padding: 6px 0;
  }

  .score-header-row {
    border-top: 1px solid #f7f7f7;
  }

  .score-cell {
    flex: 1;
    min-width: 110px;
    font-size: 13px;
    padding-right: 8px;
    word-break: break-word;
  }

  .score-empty-state {
    color: #8a8f98;
    font-size: 13px;
    padding: 6px 0;
    border-top: 1px solid #f7f7f7;
  }
}
</style>
